'use client'

import { useEffect, useState } from 'react'
import { FlagJP, FlagPK } from './Flags'

const fmt = (tz: string) =>
  new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: tz })

/** Live local time in Lahore and Tokyo (Tokyo is 4 hours ahead). */
export function LiveClocks({ locale = 'en', className = '' }: { locale?: 'en' | 'ja'; className?: string }) {
  const [now, setNow] = useState<Date | null>(null)
  useEffect(() => {
    setNow(new Date())
    const id = window.setInterval(() => setNow(new Date()), 15_000)
    return () => window.clearInterval(id)
  }, [])
  const lhr = now ? fmt('Asia/Karachi').format(now) : '--:--'
  const tyo = now ? fmt('Asia/Tokyo').format(now) : '--:--'
  return (
    <span className={`inline-flex items-center gap-3 tabular-nums ${className}`}>
      <span className="inline-flex items-center gap-1.5" title={locale === 'ja' ? 'ラホールの現在時刻' : 'Time in Lahore'}>
        <FlagPK />
        <span>{locale === 'ja' ? 'ラホール' : 'Lahore'}</span>
        <b className="font-semibold">{lhr}</b>
      </span>
      <span className="opacity-40" aria-hidden>
        ✈
      </span>
      <span className="inline-flex items-center gap-1.5" title={locale === 'ja' ? '東京の現在時刻' : 'Time in Tokyo'}>
        <FlagJP />
        <span>{locale === 'ja' ? '東京' : 'Tokyo'}</span>
        <b className="font-semibold">{tyo}</b>
      </span>
    </span>
  )
}
